"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farad = void 0;
var UnitDivide = require("../unit-divide");
var electric_charge_1 = require("./electric-charge");
var electric_potential_1 = require("./electric-potential");
/**
 * The derived unit for capacitance ( <code>F</code> ).
 * One Farad is equal to the capacitance of a capacitor having an equal and opposite charge of 1 coulomb on
 * each plate and a potential difference of 1 volt between the plates.
 * It is named after the British physicist and chemist Michael Faraday (1791-1867).
 */
exports.Farad = UnitDivide.electricChargeByElectricPotential("Farad", electric_charge_1.Coulomb, electric_potential_1.Volt);
//# sourceMappingURL=electric-capacitance.js.map